export default "__VITE_ASSET__3b84a8f2__"